export default __webpack_public_path__ + "static/gramurja-18458d5fd0174576401d779dbd174230.png";